export default "__VITE_ASSET__HfDXtVP4__"